import { render, staticRenderFns } from "./order.vue?vue&type=template&id=3e5ef03b&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MobileGoodsItem: require('/home/runner/work/myody_front/myody_front/components/mobile/goodsItem.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
